import React, { useEffect } from 'react';
import {connect} from 'react-redux'
import {Col, Row} from 'reactstrap';
import TrashIcon from 'mdi-react/TrashOutlineIcon';
import { deleteSocialWallImage, fetchEventSocialWallImages } from '@/services/events';

const SocialWallImages = ({ socialWallImage, setSocialWallImg, onCancel, onSelectIconOK, socialWallImgs, setSocialWallImages, program }) => {
  useEffect(() => {
    if (program?.id) {
      fetchEventSocialWallImages(program, 'both')
        .then(response => {
          setSocialWallImages(response)
        })
    }
  }, [program])

  const onClickDeleteIcon = (icon) => {
    deleteSocialWallImage(program, icon)
      .then(response => {
        if (response.status === 200) {
          fetchEventSocialWallImages(program, 'both')
            .then(response => {
              setSocialWallImages(response)
            })
        }
      })
  }

  const selectItem = (socialWall) => {
    setSocialWallImg(socialWall)
  }

 
  return (
    <Col md={12} lg={12} className="manager-program-settings-picker__pane">
      <Row className='w100'>
        <Col md="12" lg="12" xl="12">
          <ul className="img_wrap">
            {
              socialWallImgs.map(function (item, key) {
                return <li key={key} onClick={(e) => selectItem(item)} className={socialWallImage?.id === item.id ? 'active' : ''} md="3" lg="3" xl="3">
                  <div className='preview'>
                    <i className="fa fa-check"></i>
                    <img src={`${process.env.REACT_APP_API_STORAGE_URL}/${item.path}`} title={item.name} alt={item.name} />
                    {item.organization_id === program.organization_id && <div className="mt-2 delete-icon-icon" onClick={(e) => { if (window.confirm('Are you sure to delete this icon?')) { onClickDeleteIcon(item) } }}><TrashIcon color='#bdbdbd' /></div>}
                  </div>
                </li>
              })
            }
          </ul>
        </Col>
        <Col md="12" lg="12" xl="12">
          <div className="manager-program-settings-dialog__actions">
            <button
              type="button"
              className="manager-program-settings-dialog__action"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="manager-program-settings-dialog__action is-primary"
              onClick={() => onSelectIconOK('social_wall_image', socialWallImage)}
            >
              Select
            </button>
          </div>
        </Col>
      </Row>
    </Col>
  )
}

export default connect((state) => ({
  program: state.program
}))(SocialWallImages);
